import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import AffiliateLanding from "@/pages/AffiliateLanding";
import AffiliateSignup from "@/pages/AffiliateSignup";
import AffiliateDashboard from "@/pages/AffiliateDashboard";
import AffiliateTerms from "@/pages/AffiliateTerms";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSupport from "@/pages/AdminSupport";
import { I18nProvider } from "@/i18n/I18nContext";
import { AuthProvider } from "@/lib/auth";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 *
 * This router inspects the URL fragment synchronously during render (NOT in a
 * useEffect) so we exchange a Google `session_id` BEFORE any protected routes
 * decide what to render — avoids a race that would redirect to signup.
 */
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/affiliate" element={<AffiliateLanding />} />
      <Route path="/affiliate/signup" element={<AffiliateSignup />} />
      <Route path="/affiliate/dashboard" element={<AffiliateDashboard />} />
      <Route path="/affiliate/terms" element={<AffiliateTerms />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/support" element={<AdminSupport />} />
    </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
